(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("cUbQm", function(module, exports) {

$parcel$export(module.exports, "EstateType", function () { return $3d4be14a1fc293c1$export$7e9d4a015d94d29b; });
$parcel$export(module.exports, "FilterTypes", function () { return $3d4be14a1fc293c1$export$ad2e3f13451a5d44; });
$parcel$export(module.exports, "StatusId", function () { return $3d4be14a1fc293c1$export$d65964de2de8af23; });
$parcel$export(module.exports, "RangeTagNames", function () { return $3d4be14a1fc293c1$export$c83337b10675736d; });
$parcel$export(module.exports, "EstateStatuses", function () { return $3d4be14a1fc293c1$export$ed9dc39bdcf844d0; });
$parcel$export(module.exports, "ObjectListLayout", function () { return $3d4be14a1fc293c1$export$e182da00b572d900; });
$parcel$export(module.exports, "FilterParams", function () { return $3d4be14a1fc293c1$export$740f946a6cca8834; });
$parcel$export(module.exports, "SortType", function () { return $3d4be14a1fc293c1$export$32968d5801cea560; });
$parcel$export(module.exports, "Status", function () { return $3d4be14a1fc293c1$export$96e9906d6d93a972; });
$parcel$export(module.exports, "FarmCriteriasDefault", function () { return $3d4be14a1fc293c1$export$f8e2c7addee08b02; });
$parcel$export(module.exports, "CommercialCriteriasDefault", function () { return $3d4be14a1fc293c1$export$ce0a8fac4436d53d; });
$parcel$export(module.exports, "ExtraCriterias", function () { return $3d4be14a1fc293c1$export$e25c0f596d793823; });
$parcel$export(module.exports, "SelectedFilter", function () { return $3d4be14a1fc293c1$export$28a6bfe82cc0274b; });
$parcel$export(module.exports, "SpecialUnits", function () { return $3d4be14a1fc293c1$export$6545aef0be881c6a; });
$parcel$export(module.exports, "ButtonStrings", function () { return $3d4be14a1fc293c1$export$1862b8b0acfb3ccc; });
$parcel$export(module.exports, "BaseColorsBkg", function () { return $3d4be14a1fc293c1$export$e8df4cbe8217beb6; });
$parcel$export(module.exports, "SpinnerColors", function () { return $3d4be14a1fc293c1$export$94fe02905853ff45; });
$parcel$export(module.exports, "BrokerLoginErrors", function () { return $3d4be14a1fc293c1$export$cee9d0d568396474; });
$parcel$export(module.exports, "SearchProfile", function () { return $3d4be14a1fc293c1$export$8fb504d551a3e85c; });
$parcel$export(module.exports, "Estates", function () { return $3d4be14a1fc293c1$export$3e8a28569135f3d5; });
$parcel$export(module.exports, "ObjectPage", function () { return $3d4be14a1fc293c1$export$e951d7e8878ee8da; });
$parcel$export(module.exports, "MyPagesObject", function () { return $3d4be14a1fc293c1$export$45025dc23eb515c; });
$parcel$export(module.exports, "Common", function () { return $3d4be14a1fc293c1$export$a86fab198fa43d2c; });
$parcel$export(module.exports, "ServicesTitles", function () { return $3d4be14a1fc293c1$export$3e2cfb9c3dd67711; });
$parcel$export(module.exports, "SpeculationCheckStrings", function () { return $3d4be14a1fc293c1$export$19387ae978ee1215; });
$parcel$export(module.exports, "SpeculationCheckTypes", function () { return $3d4be14a1fc293c1$export$6343f498207c531f; });
$parcel$export(module.exports, "KycServiceNames", function () { return $3d4be14a1fc293c1$export$130946ef665c159a; });
$parcel$export(module.exports, "ConsentEnums", function () { return $3d4be14a1fc293c1$export$4659363ba646de75; });
var $3d4be14a1fc293c1$export$7e9d4a015d94d29b;
(function(EstateType) {
    EstateType["House"] = "Villa";
    EstateType["Cooperative"] = "Bostadsr\xe4tt";
    EstateType["RowHouse"] = "Radhus";
    EstateType["Cottage"] = "Fritidshus";
    EstateType["Agriculture"] = "G\xe5rd";
    EstateType["Plot"] = "Tomt";
    EstateType["Project"] = "Nyproduktion";
    EstateType["Commercial"] = "Kommersiellt";
    EstateType["OwnedApartment"] = "\xc4garl\xe4genhet";
    EstateType["Premises"] = "Lokal";
})($3d4be14a1fc293c1$export$7e9d4a015d94d29b || ($3d4be14a1fc293c1$export$7e9d4a015d94d29b = {}));
var $3d4be14a1fc293c1$export$ad2e3f13451a5d44;
(function(FilterTypes) {
    FilterTypes["AllEstates"] = "allEstates";
    FilterTypes["Area"] = "area";
    FilterTypes["Municipality"] = "munici";
    FilterTypes["County"] = "county";
    FilterTypes["EstateType"] = "estateType";
    FilterTypes["RangeTag"] = "rangeTag";
    FilterTypes["ExtraCritera"] = "extraCriteria";
    FilterTypes["Alignment"] = "alignment";
    FilterTypes["ShowSold"] = "showSold";
    FilterTypes["ShowOnlyHeadStart"] = "showOnlyHeadStart";
    FilterTypes["ShowGreenEstates"] = "showGreenEstates";
    FilterTypes["ShowBidding"] = "showBidding";
    FilterTypes["Broker"] = "broker";
    FilterTypes["Office"] = "office";
    FilterTypes["Polygons"] = "polygons";
})($3d4be14a1fc293c1$export$ad2e3f13451a5d44 || ($3d4be14a1fc293c1$export$ad2e3f13451a5d44 = {}));
var $3d4be14a1fc293c1$export$d65964de2de8af23;
(function(StatusId) {
    StatusId["Empty"] = "2M0QLN0HN8D3RCHO";
    StatusId["DuringIntake"] = "2HIII2GATHLRTMP9";
    StatusId["ForSale"] = "2HIII41T24FNHOU2";
    StatusId["Reserved"] = "2IV3QJ925HR9IFJM";
    StatusId["Sold"] = "2HIII4T0O9LMQ3UI";
    StatusId["Booked"] = "2Q92VBJ0M1E54PE4";
    StatusId["Coming"] = "2O8JBQG8CAMFQQGC";
    StatusId["UntilAdvertisement"] = "3IEABGRPJCRIS7V8";
    StatusId["Repossessed"] = "2QGS54SRFUPE1S31";
    StatusId["Quest"] = "40N3MK51AIO18SRP";
    StatusId["LostIntake"] = "40N3NETL8IO18SRQ";
    StatusId["FollowUp"] = "40N3O2RQUIO18SRR";
    StatusId["Intake"] = "40SQ6IPLMADRPBV1";
    StatusId["HeadStartHomes"] = "45D3RJETOQCL0BNL";
    StatusId["SoonForSale"] = "4744HQQP4MPMUP0N";
    StatusId["Valuation"] = "4CVJ143ID6UHMHQK";
    StatusId["Other"] = "46SJUQ47D57AV478";
    StatusId["AvailableForRent"] = "2IV3Q9RV3VFPNQCK";
    StatusId["RentedProvisionally"] = "2IV3QI9HSHNGAL43";
    StatusId["Rented"] = "2IV3QFG90LBGV1EE";
})($3d4be14a1fc293c1$export$d65964de2de8af23 || ($3d4be14a1fc293c1$export$d65964de2de8af23 = {}));
var $3d4be14a1fc293c1$export$c83337b10675736d;
(function(RangeTagNames) {
    RangeTagNames["Price"] = "Pris";
    RangeTagNames["Room"] = "Rum";
    RangeTagNames["LivingSpace"] = "Boarea";
    RangeTagNames["Charge"] = "Avgift";
    RangeTagNames["PlotArea"] = "Tomtarea";
})($3d4be14a1fc293c1$export$c83337b10675736d || ($3d4be14a1fc293c1$export$c83337b10675736d = {}));
var $3d4be14a1fc293c1$export$ed9dc39bdcf844d0;
(function(EstateStatuses) {
    EstateStatuses["Sold"] = "S\xe5ld";
    EstateStatuses["ForSale"] = "Till salu";
    EstateStatuses["Intake"] = "Under intag";
    EstateStatuses["SoldOut"] = "Sluts\xe5lt";
    EstateStatuses["Intaken"] = "Intagen";
})($3d4be14a1fc293c1$export$ed9dc39bdcf844d0 || ($3d4be14a1fc293c1$export$ed9dc39bdcf844d0 = {}));
var $3d4be14a1fc293c1$export$e182da00b572d900;
(function(ObjectListLayout) {
    ObjectListLayout["Row"] = "row";
    ObjectListLayout["Map"] = "map";
    ObjectListLayout["Grid"] = "grid";
    ObjectListLayout["ListLabel"] = "Lista";
    ObjectListLayout["MapLabel"] = "Karta";
    ObjectListLayout["BrokerLabel"] = "M\xe4klare";
    ObjectListLayout["OfficeLabel"] = "Kontor";
    ObjectListLayout["OfficeMap"] = "officeMap";
    ObjectListLayout["BrokerGrid"] = "brokerGrid";
})($3d4be14a1fc293c1$export$e182da00b572d900 || ($3d4be14a1fc293c1$export$e182da00b572d900 = {}));
var $3d4be14a1fc293c1$export$740f946a6cca8834;
(function(FilterParams) {
    FilterParams["MUNICI_PARAM"] = "municipality";
    FilterParams["COUNTY_PARAM"] = "county";
    FilterParams["AREA_PARAM"] = "areaIds";
    FilterParams["EXTRACRITERIA_PARAM"] = "extraSearch";
    FilterParams["ESTATETYPE_PARAM"] = "estateType";
    FilterParams["ALIGNMENT_PARAM"] = "alignment";
    FilterParams["PROPERTYTYPE_PARAM"] = "propertyType";
    FilterParams["PRICEMIN_PARAM"] = "priceMin";
    FilterParams["PRICEMAX_PARAM"] = "priceMax";
    FilterParams["ROOMMIN_PARAM"] = "roomsMin";
    FilterParams["ROOMMAX_PARAM"] = "roomsMax";
    FilterParams["LIVINGSPACEMIN_PARAM"] = "livingSpaceMin";
    FilterParams["LIVINGSPACEMAX_PARAM"] = "livingSpaceMax";
    FilterParams["MONTHLYCOSTMIN_PARAM"] = "monthlyCostMin";
    FilterParams["MONTHLYCOSTMAX_PARAM"] = "monthlyCostMax";
    FilterParams["PLOTAREAMIN_PARAM"] = "plotAreaMin";
    FilterParams["PLOTAREAMAX_PARAM"] = "plotAreaMax";
    FilterParams["HEADSTART_PARAM"] = "showOnlyHeadStart";
    FilterParams["SOLD_PARAM"] = "showSold";
    FilterParams["GREENESTATES_PARAM"] = "showGreenEstates";
    FilterParams["BROKERID_PARAM"] = "brokerid";
    FilterParams["CUSTOMERID_PARAM"] = "customerId";
    FilterParams["SORT_PARAM"] = "sortOrder";
    FilterParams["BIDDING_PARAM"] = "showBidding";
    FilterParams["POLYGON_PARAM"] = "polygons";
})($3d4be14a1fc293c1$export$740f946a6cca8834 || ($3d4be14a1fc293c1$export$740f946a6cca8834 = {}));
const $3d4be14a1fc293c1$export$32968d5801cea560 = [
    {
        id: "0",
        label: "Visningsdatum"
    },
    {
        id: "1",
        label: "Senast inkommet"
    },
    {
        id: "2",
        label: "Pris stigande"
    },
    {
        id: "3",
        label: "Pris fallande"
    },
    {
        id: "4",
        label: "Boarea stigande"
    },
    {
        id: "5",
        label: "Boarea fallande"
    },
    {
        id: "6",
        label: "Antal rum stigande"
    },
    {
        id: "7",
        label: "Antal rum fallande"
    },
    {
        id: "8",
        label: "Tomtarea"
    }
];
var $3d4be14a1fc293c1$export$96e9906d6d93a972;
(function(Status) {
    Status["forSale"] = "Till salu";
    Status["headStart"] = "Kommande f\xf6rs\xe4ljning";
    Status["headStartPlural"] = "Kommande f\xf6rs\xe4ljningar";
    Status["sold"] = "S\xe5lda bost\xe4der";
})($3d4be14a1fc293c1$export$96e9906d6d93a972 || ($3d4be14a1fc293c1$export$96e9906d6d93a972 = {}));
const $3d4be14a1fc293c1$export$f8e2c7addee08b02 = [
    {
        id: "Fritid"
    },
    {
        id: "Skog"
    },
    {
        id: "H\xe4stg\xe5rd"
    },
    {
        id: "Spannm\xe5l"
    },
    {
        id: "K\xf6tt"
    },
    {
        id: "Svin"
    },
    {
        id: "Mj\xf6lk"
    }
];
const $3d4be14a1fc293c1$export$ce0a8fac4436d53d = [
    {
        id: "Kontor"
    },
    {
        id: "Bost\xe4der"
    },
    {
        id: "Butiker"
    },
    {
        id: "Lager/logistik"
    },
    {
        id: "Industri/verkstad"
    }
];
const $3d4be14a1fc293c1$export$e25c0f596d793823 = {
    "0": {
        id: "0",
        text: "Bastu",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "1": {
        id: "1",
        text: "Bottenplan",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "2": {
        id: "2",
        text: "Ej bottenplan",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "23": {
        id: "23",
        text: "Elbilsladdare",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "G\xe5rd",
            "Kommersiellt",
            "Nyproduktion",
            "Kommersiellt"
        ]
    },
    "3": {
        id: "3",
        text: "Eldstad",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd"
        ]
    },
    "4": {
        id: "4",
        text: "Enplanshus",
        belongsTo: [
            "Villa",
            "Fritidshus"
        ]
    },
    "6": {
        id: "6",
        text: "Etagel\xe4genhet",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "7": {
        id: "7",
        text: "Exklusivt",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd",
            "Tomt",
            "Kommersiellt"
        ]
    },
    "8": {
        id: "8",
        text: "Fri utsikt",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd",
            "Tomt",
            "Kommersiellt"
        ]
    },
    "9": {
        id: "9",
        text: "Garage",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "Nyproduktion",
            "Kommersiellt",
            "G\xe5rd",
            "\xc4garl\xe4genhet"
        ]
    },
    "12": {
        id: "12",
        text: "Havsutsikt",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd",
            "Tomt",
            "Kommersiellt"
        ]
    },
    "15": {
        id: "15",
        text: "H\xf6gt l\xe4ge",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "14": {
        id: "14",
        text: "N\xe4ra vatten",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "Nyproduktion",
            "Tomt",
            "\xc4garl\xe4genhet",
            "G\xe5rd"
        ]
    },
    "25": {
        id: "25",
        text: "Privat pool",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "G\xe5rd"
        ]
    },
    "24": {
        id: "24",
        text: "Solceller",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "G\xe5rd",
            "Nyproduktion",
            "Kommersiellt"
        ]
    },
    "13": {
        id: "13",
        text: "Sj\xf6utsikt",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd",
            "Tomt",
            "Kommersiellt"
        ]
    },
    "5": {
        id: "5",
        text: "Takv\xe5ning",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "16": {
        id: "16",
        text: "Renoveringsobjekt",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd",
            "Kommersiellt"
        ]
    },
    "22": {
        id: "22",
        text: "Seniorboende",
        belongsTo: [
            "Villa",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "17": {
        id: "17",
        text: "Strandn\xe4ra",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "Nyproduktion",
            "Tomt",
            "\xc4garl\xe4genhet",
            "Kommersiellt"
        ]
    },
    "18": {
        id: "18",
        text: "Takterass",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "19": {
        id: "19",
        text: "Tr\xe4dg\xe5rd",
        belongsTo: [
            "Villa",
            "Fritidshus",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet",
            "G\xe5rd",
            "Kommersiellt"
        ]
    },
    "21": {
        id: "21",
        text: "Uthyrningsdel",
        belongsTo: [
            "Villa",
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    },
    "20": {
        id: "20",
        text: "Vindsv\xe5ning",
        belongsTo: [
            "Bostadsr\xe4tt",
            "\xc4garl\xe4genhet"
        ]
    }
};
var $3d4be14a1fc293c1$export$28a6bfe82cc0274b;
(function(SelectedFilter) {
    SelectedFilter["SearchProfileId"] = "ProfileId";
    SelectedFilter["Area"] = "selectedAreas";
    SelectedFilter["Municipality"] = "selectedMunicips";
    SelectedFilter["EstateType"] = "selectedEstateType";
    SelectedFilter["PriceMin"] = "selectedPriceMin";
    SelectedFilter["PriceMax"] = "selectedPriceMax";
    SelectedFilter["RoomMin"] = "selectedRoomMin";
    SelectedFilter["RoomMax"] = "selectedRoomMax";
    SelectedFilter["LivingMin"] = "selectedLivingspaceMin";
    SelectedFilter["LivingMax"] = "selectedLivingspaceMax";
    SelectedFilter["ChargeMin"] = "selectedChargeMin";
    SelectedFilter["ChargeMax"] = "selectedChargeMax";
    SelectedFilter["PlotMin"] = "selectedPlotMin";
    SelectedFilter["PlotMax"] = "selectedPlotMax";
    SelectedFilter["ExtraCrits"] = "selectedExtraCrits";
    SelectedFilter["Polygons"] = "selectedDrawnAreas";
})($3d4be14a1fc293c1$export$28a6bfe82cc0274b || ($3d4be14a1fc293c1$export$28a6bfe82cc0274b = {}));
var $3d4be14a1fc293c1$export$6545aef0be881c6a;
(function(SpecialUnits) {
    SpecialUnits["square"] = "m\xb2";
    SpecialUnits["cash"] = "kr";
})($3d4be14a1fc293c1$export$6545aef0be881c6a || ($3d4be14a1fc293c1$export$6545aef0be881c6a = {}));
var $3d4be14a1fc293c1$export$1862b8b0acfb3ccc;
(function(ButtonStrings) {
    ButtonStrings["saveAndContinue"] = "Spara och forts\xe4tt senare";
    ButtonStrings["doneAndSend"] = "Klar! Skicka till m\xe4klare";
    ButtonStrings["saveAssignments"] = "Spara uppgifter";
    ButtonStrings["sendAllToBroker"] = "Skicka alla uppgifter till min m\xe4klare";
    ButtonStrings["sendNewChanges"] = "Skicka nya \xe4ndringar till min m\xe4klare";
    ButtonStrings["sendDocument"] = "Skicka in dokument";
    ButtonStrings["yesImSure"] = "Ja, jag \xe4r s\xe4ker";
    ButtonStrings["noTakeMeBack"] = "Nej, ta mig tillbaka";
    ButtonStrings["editSearchprofile"] = "Redigera bevakning";
    ButtonStrings["removeSearchprofile"] = "Ta bort bevakning";
    ButtonStrings["createNewSearchProfile"] = "Skapa ny bevakning";
    ButtonStrings["goBack"] = "Tillbaka";
    ButtonStrings["next"] = "N\xe4sta";
    ButtonStrings["seAllSpeculants"] = "Se antal spekulanter";
    ButtonStrings["calculateAgain"] = "Ber\xe4kna antal spekulanter igen";
    ButtonStrings["seeResult"] = "Se resultat";
})($3d4be14a1fc293c1$export$1862b8b0acfb3ccc || ($3d4be14a1fc293c1$export$1862b8b0acfb3ccc = {}));
var $3d4be14a1fc293c1$export$e8df4cbe8217beb6;
(function(BaseColorsBkg) {
    BaseColorsBkg["Blue700"] = "bg-blue700";
    BaseColorsBkg["White"] = "bg-white";
    BaseColorsBkg["Grey100"] = "bg-grey100";
})($3d4be14a1fc293c1$export$e8df4cbe8217beb6 || ($3d4be14a1fc293c1$export$e8df4cbe8217beb6 = {}));
var $3d4be14a1fc293c1$export$94fe02905853ff45;
(function(SpinnerColors) {
    SpinnerColors["Blue700"] = "blue-spinner";
    SpinnerColors["Black500"] = "secondary-spinner";
    SpinnerColors["White"] = "white-spinner";
})($3d4be14a1fc293c1$export$94fe02905853ff45 || ($3d4be14a1fc293c1$export$94fe02905853ff45 = {}));
var $3d4be14a1fc293c1$export$cee9d0d568396474;
(function(BrokerLoginErrors) {
    BrokerLoginErrors["ContactNotFoundInVitec"] = "ContactNotFoundInVitec";
    BrokerLoginErrors["TokenExpiredOrEmpty"] = "TokenExpiredOrEmpty";
    BrokerLoginErrors["UserNotFoundInMyPages"] = "UserNotFoundInMyPages";
    BrokerLoginErrors["WrongEntryWay"] = "WrongEntryWay";
})($3d4be14a1fc293c1$export$cee9d0d568396474 || ($3d4be14a1fc293c1$export$cee9d0d568396474 = {}));
var $3d4be14a1fc293c1$export$8fb504d551a3e85c;
(function(SearchProfile) {
    SearchProfile["SearchProfileHeadline"] = "Bevaka s\xf6kning";
    SearchProfile["NoParams"] = "F\xf6r att spara en bevakning m\xe5ste du ha valt n\xe5gra s\xf6kparametrar.";
    SearchProfile["SearchSummary"] = "Sammanfattning av s\xf6kning";
    SearchProfile["FillInformation"] = "Ange dina uppgifter";
    SearchProfile["ErrorBroker"] = "Tyv\xe4rr kan du inte bevaka en m\xe4klare eller ett kontors aktuella bost\xe4der. F\xf6rs\xf6k hitta andra l\xe4mpliga s\xf6kalternativ.";
    SearchProfile["ErrorNotAllParams"] = "F\xf6r att skapa en bevakning beh\xf6ver du v\xe4lja en <strong>kommun, omr\xe5de (ej l\xe4n) eller rita ut ett omr\xe5de</strong>, samt en <strong>bostadstyp</strong>.";
    SearchProfile["SeveralError"] = "Tyv\xe4rr kan du inte bevaka flera objekttyper samtidigt.  Beh\xe5ll en objekttyp f\xf6r att skapa bevakning.";
    SearchProfile["CountyError"] = "Tyv\xe4rr kan du inte bevaka bost\xe4der i ett l\xe4n. F\xf6rs\xf6k igen med kommun.";
    SearchProfile["FarmPlotError"] = "Tomtarea \xe4r tyv\xe4rr inte applicerbart p\xe5 g\xe5rd.";
    SearchProfile["ForbiddenTypesError"] = "Tyv\xe4rr kan du inte skapa en bevakning p\xe5 <strong>nyproduktion</strong> och <strong>kommersiellt</strong>.";
    SearchProfile["IntroText"] = "H\xe4r skapar du bevakningen s\xe5 att du garanterat inte missar den dag d\xe5 ditt dr\xf6mboende dyker upp. Ange dina uppgifter h\xe4r s\xe5 mailar vi dig n\xe4r matchande bost\xe4der dyker upp!";
    SearchProfile["SavedSearchProfile"] = "Din bevakning \xe4r sparad!";
    SearchProfile["GoToMyPages"] = "G\xe5 till mina sidor";
    SearchProfile["MyPagesTextLoggedIn"] = "Du kommer fram\xf6ver f\xe5 mail med intressanta bost\xe4der baserat p\xe5 din bevakning. Vill du sj\xe4lv redigera dina bevakningar och f\xf6lja upp dem h\xe4r p\xe5 hemsidan g\xe5r du till";
    SearchProfile["MyPagesText"] = "Du kommer fram\xf6ver f\xe5 mail med intressanta bost\xe4der baserat p\xe5 din bevakning. Vill du sj\xe4lv redigera dina bevakningar och f\xf6lja upp dem h\xe4r p\xe5 hemsidan beh\xf6ver du skapa ett konto eller logga in p\xe5 mina sidor.";
    SearchProfile["AutoGenerated"] = "Autogenererad";
})($3d4be14a1fc293c1$export$8fb504d551a3e85c || ($3d4be14a1fc293c1$export$8fb504d551a3e85c = {}));
var $3d4be14a1fc293c1$export$3e8a28569135f3d5;
(function(Estates) {
    Estates["GreenEstate"] = "H\xe5llbart val";
    Estates["LDPlus"] = "F\xf6rs\xe4krad Plus";
    Estates["SearchEstate"] = "S\xf6k bostad";
    Estates["SearchPlaceholder"] = "S\xf6k p\xe5 kommun, omr\xe5de eller adress";
    Estates["CreateSearchProfile"] = "Skapa bevakning";
})($3d4be14a1fc293c1$export$3e8a28569135f3d5 || ($3d4be14a1fc293c1$export$3e8a28569135f3d5 = {}));
var $3d4be14a1fc293c1$export$e951d7e8878ee8da;
(function(ObjectPage) {
    ObjectPage["HeliView"] = "Helikoptervy";
    ObjectPage["ThreeDView"] = "3D Visning";
    ObjectPage["Document"] = "Dokument";
})($3d4be14a1fc293c1$export$e951d7e8878ee8da || ($3d4be14a1fc293c1$export$e951d7e8878ee8da = {}));
var $3d4be14a1fc293c1$export$45025dc23eb515c;
(function(MyPagesObject) {
    MyPagesObject["SendDocumentText"] = "H\xe4r kan du ladda upp och skicka dokument till din m\xe4klare. Det skulle t.ex. kunna vara ett bygglov eller \xe5rsredovisning.";
    MyPagesObject["SendDocumentHeadline"] = "Skicka dokument";
})($3d4be14a1fc293c1$export$45025dc23eb515c || ($3d4be14a1fc293c1$export$45025dc23eb515c = {}));
var $3d4be14a1fc293c1$export$a86fab198fa43d2c;
(function(Common) {
    Common["Back"] = "Tillbaka";
    Common["Close"] = "St\xe4ng";
})($3d4be14a1fc293c1$export$a86fab198fa43d2c || ($3d4be14a1fc293c1$export$a86fab198fa43d2c = {}));
var $3d4be14a1fc293c1$export$3e2cfb9c3dd67711;
(function(ServicesTitles) {
    ServicesTitles["GreenEstate"] = "Bra energiklass";
    ServicesTitles["HeadStart"] = "Kommande f\xf6rs\xe4ljning";
    ServicesTitles["LD"] = "F\xf6rs\xe4krad Plus";
})($3d4be14a1fc293c1$export$3e2cfb9c3dd67711 || ($3d4be14a1fc293c1$export$3e2cfb9c3dd67711 = {}));
var $3d4be14a1fc293c1$export$19387ae978ee1215;
(function(SpeculationCheckStrings) {
    SpeculationCheckStrings["EnterSquaremeters"] = "Ange kvadratmeter";
    SpeculationCheckStrings["EnterRoomsExKitchen"] = "Ange rum, exklusive k\xf6k";
    SpeculationCheckStrings["EnterMonthlyFee"] = "Ange m\xe5nadskostnad";
    SpeculationCheckStrings["EnterSum"] = "Ange belopp";
})($3d4be14a1fc293c1$export$19387ae978ee1215 || ($3d4be14a1fc293c1$export$19387ae978ee1215 = {}));
var $3d4be14a1fc293c1$export$6343f498207c531f;
(function(SpeculationCheckTypes) {
    SpeculationCheckTypes["EstateType"] = "Bostadstyp";
    SpeculationCheckTypes["Address"] = "Adress";
    SpeculationCheckTypes["LivingArea"] = "Boarea";
    SpeculationCheckTypes["Rooms"] = "Rum";
    SpeculationCheckTypes["MonthlyFee"] = "M\xe5nadsavgift";
    SpeculationCheckTypes["PlotArea"] = "Tomtarea";
    SpeculationCheckTypes["SellPrice"] = "F\xf6rs\xe4ljningspris";
    SpeculationCheckTypes["Message"] = "Meddelande";
})($3d4be14a1fc293c1$export$6343f498207c531f || ($3d4be14a1fc293c1$export$6343f498207c531f = {}));
var $3d4be14a1fc293c1$export$130946ef665c159a;
(function(KycServiceNames) {
    KycServiceNames["Kyc"] = "Kundk\xe4nnedom";
    KycServiceNames["KycBuyer"] = "Kundk\xe4nnedom k\xf6pare";
    KycServiceNames["KycSeller"] = "Kundk\xe4nnedom s\xe4ljare";
})($3d4be14a1fc293c1$export$130946ef665c159a || ($3d4be14a1fc293c1$export$130946ef665c159a = {}));
var $3d4be14a1fc293c1$export$4659363ba646de75;
(function(ConsentEnums) {
    ConsentEnums["Approved"] = "Approved";
    ConsentEnums["Declined"] = "Declined";
    ConsentEnums["Revoked"] = "Revoked";
    ConsentEnums["Dismissed"] = "Dismissed";
    ConsentEnums["Faulted"] = "Faulted";
    ConsentEnums["ApprovedLabel"] = "Godk\xe4nt";
    ConsentEnums["DeclinedLabel"] = "Nekat";
    ConsentEnums["RevokedLabel"] = "\xc5terkallat";
    ConsentEnums["FaultedLabel"] = "Ej tillg\xe4ngligt";
    ConsentEnums["NoAnswerLabel"] = "Obesvarat";
    ConsentEnums["ApproveLabel"] = "Ja, jag samtycker";
    ConsentEnums["DeclineLabel"] = "Nej, inte just nu";
    ConsentEnums["RevokeLabel"] = "\xc5terkalla ditt samtycke";
    ConsentEnums["GetConsentError"] = "H\xe4mtningen utav samtyckes uppgifter misslyckades, testa igen senare eller kontakta support.";
    ConsentEnums["HandleConsentError"] = "N\xe5got gick fel vid hanteringen utav samtycket. V\xe4nligen f\xf6rs\xf6k igen eller kontakta support.";
    ConsentEnums["DismissedKey"] = "consentModalDismissed";
    ConsentEnums["FaultedError"] = "N\xe5got har g\xe5tt fel kopplat till samtycket, vi jobbar p\xe5 det.";
})($3d4be14a1fc293c1$export$4659363ba646de75 || ($3d4be14a1fc293c1$export$4659363ba646de75 = {}));

});

})();
//# sourceMappingURL=ObjectPage.bc26dc06.js.map
